export const IdConstants = {
    HowItWorks: 'HowItWorks',
    AboutUs: 'AboutUs',
    FAQ: 'FAQ',
    Download: 'Download'
}
